import styled from "styled-components"

import Flex from "./flex.js"

const Row = styled(Flex).attrs(({alignItems, reverse}) => ({
  flexDirection: reverse ? "row-reverse" : "row",
  alignItems: alignItems ?? "center",
}))``
Row.displayName = "Row"

export default Row
